import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlSliderThumbColors = createInteractiveColorVar('controls-slider-thumb');
const ControlSliderThumbColorsLightValues = Object.freeze({
    default: '#FEFEFE',
    action: '#F1F1F1',
    active: '#FEFEFE',
    activeAction: '#F1F1F1',
});
const ControlSliderThumbColorsDarkValues = Object.freeze({
    default: '#FFFFFF',
    action: '#F1F1F1',
    active: '#FFFFFF',
    activeAction: '#F1F1F1',
});

export { ControlSliderThumbColors, ControlSliderThumbColorsDarkValues, ControlSliderThumbColorsLightValues };
